<template>
  <div id="new_account" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>アカウント情報入力</h2>
          <label>下記フォームより入力してください。</label>
        </div>
        <dd-account-input
          ref="accountInput"
          :isEdit="true"
          :accountForm="accountForm"
          :isManager="true"
        />
        <div id="regist_btn">
          <button class="main_btn cancel_btn" @click="cancel()">戻る</button>
          <button class="main_btn" @click="update()">更新する</button>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// Module
import Header from '../components/common/DcHeader'
import AccountInput from '../components/user/AccountInput'

export default {
  name: 'UpdateAccountInput',
  components: {
    'dd-header': Header,
    'dd-account-input': AccountInput,
    'dd-loading-modal': LoadingModal
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      accountForm: {
        email: ''
      },
      errors: {
        email: ''
      }
    }
  },
  computed: {
  },
  methods: {
    cancel: function () {
      this.$router.go(-1)
    },
    update: function () {
      this.$refs.loadingModalRef.showModal(true)
      let ret = this.$refs.accountInput.confirm()
      if (!ret) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }

      this.errors = {}

      // DBに登録する
      let payload = {
        mailAddress: this.accountForm.email
      }
      axios.post(DC_URL.USER + '/update-account-check', payload
      ).then(response => {
        if (response.data.errorMessage) {
          this.errors['email'] = response.data.errorMessage
          this.$refs.accountInput.setErrorMessage(this.errors)
        } else {
          App.setLocalStorage(DC_STORAGE_KEY.UPDATE_USER, true)
          this.$router.push({
            name: 'UpdateAccountConfirm'
          })
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    fetchData: function () {
      this.accountForm = App.getLocalStorage(DC_STORAGE_KEY.ACCOUNT_DATA)
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/UpdateAccountInput.vue